export class StringUtil {

    /**
     * currency formatter
     * 
     * @param value 
     * @param options 
     * @returns 
     */
    public static toCurrency(value: number, options: { round?: boolean, fractionDigits?: number } = { round: true, fractionDigits: 0 }): string {
        const roundedValue = !options?.fractionDigits ? Math.floor((value ?? 0) + (options?.round ? .5 : 0)) : value;
        return '$ ' + roundedValue.toLocaleString('en-US', { style: 'decimal', currency: 'USD', minimumFractionDigits: options?.fractionDigits ?? 0, maximumFractionDigits: options?.fractionDigits ?? 0 });
    }


    /**
     * percentage
     * 
     * @param value 
     * @param options 
     */
    public static toPercent(value: number, options: { fractionDigits?: number } = { fractionDigits: 0 }): string {
        const roundedValue = value;
        return roundedValue.toLocaleString('en-US', { style: 'percent', minimumFractionDigits: options?.fractionDigits ?? 2 });
    }

    /**
     * 
     * @param email 
     * @returns 
     */
    public static validateEmailFormat(email: string): boolean {
        const emailRegexp = new RegExp(
            /^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i
        )          
        return emailRegexp.test(email)
    }

    /**
     * 
     * 
     * @param key 
     * @returns 
     * 
     * @tutorial https://stackoverflow.com/questions/105034/how-to-create-guid-uuid
     */
     public static newId(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}